var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart-widget"},[_c('b-card',{attrs:{"header":_vm.title}},[_c('LineGraph',{attrs:{"height":_vm.height,"options":_vm.lineOptions,"chart-data":_vm.chartData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }